import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconNames, DateWithTimezones } from '../../common';
import { DISPLAY_DATE_FORMAT } from '../../common/constants/date-config';

@Component({
  selector: 'ui-profile-and-local-dates-with-divider',
  templateUrl: './profile-and-local-dates-with-divider.component.html',
  styleUrls: ['./profile-and-local-dates-with-divider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileAndLocalDatesWithDividerComponent {
  @Input() label: string;
  @Input() startDate: DateWithTimezones;
  @Input() endDate: DateWithTimezones;

  @Input() arrivalDeviation: string;
  @Input() departureDeviation: string;

  @Input() showWarningIcon: boolean;
  @Input() warningMessage: string;

  dateFormat = DISPLAY_DATE_FORMAT;
  iconNameList = IconNames;
}
